import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { pageService } from "@/services/api/cresivoxServer"; // Adjust the import based on your structure
import { iTabDataDTO, REDUCER_NAME } from "./Types";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);
import {httpStatusCodes} from "@/customTypes/NetworkTypes";

// Thunk to fetch all tabs
// export const getTabList = createAsyncThunk<
//   iGenericResponse<any> | null,
//   void,
//   { rejectValue: iStateMessage }
// >(
//   `${REDUCER_NAME}/getTabList`,
//         //@ts-ignore
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await pageService.getAllTabs();
//       if (response) {
//         return response; // Ensure this matches iGenericResponse<any>
//       } else {
//         return rejectWithValue({ message: "No data received" });
//       }
//     } catch (error) {
//       console.error("Error fetching tab list:", error);
//       return rejectWithValue({ message: "Failed to fetch tabs" });
//     }
//   }
// );

export const  getTabList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getTabList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
    try {
      const response = await pageService.getAllTabs();
      if (response) {
        const {httpStatusCode, data, message} = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);


export const  getTabData = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { tabId: string },

  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getTabData"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
    try {
      const response =  await pageService.getTabData(arg.tabId);
      if (response) {
        const {httpStatusCode, data, message} = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);
export const  getTermsData = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { tabId: string },

  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getTermsData"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
    try {
      const response =  await pageService.getTermData(arg.tabId);
      if (response) {
        const {httpStatusCode, data, message} = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);

// Thunk to create or update a tab
export const createOrUpdateTab = createAsyncThunk<
  iGenericResponse<any> | null,
  { tabId: string; data: iTabDataDTO },
  { rejectValue: iStateMessage }
>(
  `${REDUCER_NAME}/createOrUpdateTab`,

  async (arg, { rejectWithValue }) => {
    try {
      const response = await pageService.createOrUpdateTab(arg.tabId, arg.data);
      if (response) {
        return response; // Ensure this matches iGenericResponse<any>
      } else {
        return rejectWithValue({ message: "No data received" });
      }
    } catch (error) {
      console.error("Error creating or updating tab:", error); // Log the error
      return rejectWithValue({ message: "Failed to create or update tab" });
    }
  }
);

// Thunk to delete a tab
export const deleteTab = createAsyncThunk<
  iGenericResponse<any> | null,
  { tabId: string },
  { rejectValue: iStateMessage }
>(
  `${REDUCER_NAME}/deleteTab`,

  async (arg, { rejectWithValue }) => {
    try {
      const response = await pageService.deleteTab(arg.tabId);
      if (response) {
        return response; // Ensure this matches iGenericResponse<any>
      } else {
        return rejectWithValue({ message: "No data received" });
      }
    } catch (error) {
      console.error("Error deleting tab:", error);
      return rejectWithValue({ message: "Failed to delete tab" });
    }
  }
);